<template>
  <div id="trashRecoverManage">
    <el-row class="clearfix" style="margin-bottom: 15px;">
      <el-col class="fl" :span="2"><el-button size="medium" type="success" @click="createClass">新建废宝</el-button></el-col>
      <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
      <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogCreate" :close-on-click-modal="false" width="500px"@close="emptyDialog('materForm')">
        <el-form ref="materForm" :model="materForm" label-width="100px" :label-position="labelPosition":rules="materFormRules">
          <el-form-item label="废宝类型：" prop="wasteTreasureName">
            <el-input :disabled="canSet" v-model.trim="materForm.wasteTreasureName"></el-input>
          </el-form-item>
          <el-form-item label="启用状态：" prop="state">
            <el-switch v-model="materForm.state" :active-value="1"
                       :inactive-value="-1" ></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" >
          <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('materForm')">添加</el-button>
          <el-button v-else type="success" @click="saveEventFormSubmitBtn('materForm')">保存</el-button> 
          <el-button @click="emptyDialog('materForm')">取 消</el-button> 
        </span> 
      </el-dialog>
    </el-row>
    <el-col class="fl" style="width: 17%;">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" :label-position="labelPosition">
        <el-input clearable v-model.trim="searchForm.wasteTreasureName" placeholder="请输入废宝类型" style="margin-bottom: 15px;"></el-input>
        <el-button type="success" @click="SubmitSearch('searchForm')" style="width: 100%;">检索废宝类型</el-button>
      </el-form>
      <el-button type="text" @click="clearFrom()" class="fr" style="width: 60px;color: #169BD5;">重置</el-button>
    </el-col>
    <el-card class="box-card fr" style="width: 80%;">
      <el-table
        :data="returnData"
        border
        :header-cell-style="{'text-align':'center'}"
        style="width: 100%">
        <el-table-column
          align="center"
          prop="wasteTreasureName"
          label="废宝类型">
        </el-table-column>
        <el-table-column
          align="center"
          prop="state"
          width="250"
          label="状态">
          <template  slot-scope="scope" :keys="index">
            <span v-if="scope.row.state == '1'">启用</span>
            <span v-if="scope.row.state == '-1'">禁用</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button @click.stop="exitBtn(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
  import {
  selectWasteTreasure,updateWasteTreasure,insertWasteTreasure
  } from "../../api/api";
  export default {
    name: 'trashRecoverManage',
    data () {
      const validateNumber = (rule, value, callback) => {
        if (/^[1-9]\d*|0$/.test(value) == false) {
          callback(new Error("请输入一个大于0的整数"));
        }else {
          callback();
        }
      }
      return {
        canSet:false,
        dislogCreate:false,
        labelPosition:'left',
        dialogMenuStatus: "",
        textMenu: {
          update: "修改废宝",
          create: "新增废宝"
        },
        materForm:{
          wasteTreasureName: '',
          state: 1,
        },
        materFormRules:{//validateRoleName
          wasteTreasureName: [{ required: true, message: "请输入废宝类型", trigger: "blur" }],
        },
        searchForm:{
          wasteTreasureName:'',
          state:1,
        },
        returnData: []
      }
    },
    mounted () {
      this.getWasteTreasureList()
    },
    methods: {
      //获取废宝列表
      getWasteTreasureList() {
        
        const TreasureName= this.searchForm.wasteTreasureName
        const TreasureData = {wasteTreasureName:TreasureName}
        selectWasteTreasure(TreasureData).then(res => {
          if (res.data.status==100) {
            this.returnData = res.data.results
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //清空form
      emptyDialog(formName) {
        this.$refs[formName].resetFields();
        this.dislogCreate = false
      },
      //新建
      createClass() {
        this.materForm = {
          wasteTreasureName: '',
          state: 1,
        },
        this.dialogMenuStatus = "create";
        this.dislogCreate = true;
        this.canSet = false
      },
      //确定新增
      addEventFormSubmitBtn(formname){
        this.$refs[formname].validate((valid) => {
          if (valid) {
            let para={
              wasteTreasureName: this.materForm.wasteTreasureName,
              state: this.materForm.state
            }
            insertWasteTreasure(para).then(res => {
              if (res.data.status==100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dislogCreate = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.getWasteTreasureList();
              }else{
                 this.$message({
                    message: res.data.message,
                    type: "error"
                  });
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
      //编辑分类
      exitBtn(index,item) {
        this.canSet = true
        this.dislogCreate = true
        this.dialogMenuStatus = "update";
        this.materForm = Object.assign({}, item);
      },
      //确定保存分类
      saveEventFormSubmitBtn(formname){
        this.$refs[formname].validate((valid) => {
          if (valid) {
            /*获取当前input上输入的文字*/
            let para={
              wasteTreasureId: this.materForm.wasteTreasureId,
              state: this.materForm.state,
            }
            updateWasteTreasure(para).then(res => {
              if (res.status===200) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dislogCreate = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.getWasteTreasureList();
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
      //清空刷新
      refresh() {
        this.getWasteTreasureList()
      },
      //确认检索
      SubmitSearch() {
        this.getWasteTreasureList()
      },
      clearFrom(){
        this.searchForm = {}
      }
    },
    computed: {
    },
    watch: {
      
    }
  }
</script>

<style lang="scss" type="text/css">
  /*@import './assets/css/gome.base.css';*/
  /*@import '../node_modules/iview/dist/styles/iview.css';*/
</style>



// WEBPACK FOOTER //
// trashRecoverManage.vue?56449eee